module.exports = "/assets/data/0b72ef9d32b99540d23572509f13549d-NP11.data.json";